import styled from "styled-components";

const DefaultBox = styled.div`
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.4rem;
    height: 3.4rem;
    border: 1px solid  ${props => props.theme.colors.boxBorderContrast};
    border-radius: 50%;
    margin-right: 10px;

    svg{
        height: 23px;
        width: 23px;
    }
`;

export const LobbyHeaderDefaultButtonsBox = DefaultBox;